module.exports = __webpack_public_path__ + "img/video-icon.400c3221.jpeg";